import { MoreParameters } from "./MoreParameters";
import styles from "./parameterForms.module.css";
import { declaredDefault } from "./parameterValues";
import { TimestampControl } from "./TimestampControl";
import { TopicNameControl } from "./TopicNameControl";
import { type ParameterFormProps } from "./types";

const COVERED_KEYS = [
  "TIMESTAMP_KEY",
  "TIMESTAMP_FORMAT",
  "TOPIC_NAME",
  "TOPIC_NAME_FROM_FILE_NAME_REGEX",
] as const;

/** Units in the long spelling this action is sent; the short ones read back. */
const CSV_UNITS = [
  { value: "seconds", label: "Seconds", aliases: ["s"] },
  { value: "milliseconds", label: "Milliseconds", aliases: ["ms"] },
  { value: "microseconds", label: "Microseconds", aliases: ["us"] },
  { value: "nanoseconds", label: "Nanoseconds", aliases: ["ns"] },
] as const;

/** `csv_ingestion`: one CSV file becomes one topic. */
export function CsvIngestionForm(props: ParameterFormProps) {
  const { name, action, exampleFileName } = props;
  return (
    <div className={styles.form} data-testid="parameter-form-csv_ingestion">
      <TimestampControl
        name={name}
        columnKey="TIMESTAMP_KEY"
        unitKey="TIMESTAMP_FORMAT"
        units={CSV_UNITS}
        defaultUnit={
          declaredDefault(action, "TIMESTAMP_FORMAT", "seconds") ?? "seconds"
        }
        defaultColumn={declaredDefault(action, "TIMESTAMP_KEY", "timestamp")}
        unitHint="ISO 8601 timestamps are detected automatically."
      />
      <TopicNameControl
        name={name}
        exampleFileName={exampleFileName ?? "example.csv"}
        fallsBackToFileName
      />
      <MoreParameters {...props} coveredKeys={COVERED_KEYS} />
    </div>
  );
}
